<script setup lang="ts">
import ClaimCertificateSVG from '@/assets/images/illustrations/claim-certificate.svg';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import type { CourseCertificateStatusType } from "~/types/course.types";
import { CourseCertificateStatus } from "~/enums/course.enums";

defineProps<{
  state: CourseCertificateStatusType;
}>();

const emit = defineEmits<{
  (e: 'claimCertificate', callback: () => void): void;
}>();

const { t } = useI18n();

const loading = ref<boolean>(false);

const claimCertificate = async () => {
  loading.value = true;

  emit('claimCertificate', () => {
    loading.value = false;
  });
};
</script>

<template>
  <Card
    class="rounded-2xl shadow-medmastery mt-14"
    :pt="{
      content: {
        class: 'p-0'
      }
    }"
  >
    <template #content>
      <div class="flex justify-center -mt-16">
        <ClaimCertificateSVG />
      </div>

      <div class="text-center text-24 text-neutral-90 font-bold mt-4">
        {{t('course.playlist.certificateCard.title')}}
      </div>

      <div class="text-center text-18 mt-2">
        {{t('course.playlist.certificateCard.subtitle')}}
      </div>

      <div
        v-if="[CourseCertificateStatus.BasicReady, CourseCertificateStatus.BasicClaimed].includes(state as CourseCertificateStatus)"
        class="text-center mt-4 text-neutral-40 italic text-12"
      >
        {{t('course.playlist.certificateCard.note')}}
      </div>

      <Button
        :disabled="loading"
        class="font-bold !text-22 text-nowrap flex gap-4 px-12 bg-blue-30 text-neutral-90 border-none rounded-full w-full justify-center mt-6"
        :loading="loading"
        @click="claimCertificate"
      >
        <span v-if="state === CourseCertificateStatus.CmeReady">{{t('course.playlist.certificateCard.button.claim')}}</span>
        <span v-else>{{t('course.playlist.certificateCard.button.download')}}</span>

        <FontAwesomeIcon
          v-if="!!loading"
          icon="fa-circle-notch"
          class="animate-spin"
        />
        <FontAwesomeIcon
          v-else
          icon="fa-down-to-bracket"
        />
      </Button>
    </template>
  </Card>
</template>
